var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('h6',{staticClass:"caption grey--text"},[_vm._v(" © "+_vm._s(("2017 - " + (new Date().getFullYear())))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }